import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

export interface CrossFormationReportPayload {
	report: string;
	source_reports: string[];
	excluded_formations?: string[];
	filters: {
		themes?: string[];
		formateurs?: string[];
		commanditaires?: string[];
		with_comments?: boolean;
		date_start?: number;
		date_end?: number;
	};
}

export interface PreviewThematique {
	_id: string;
	name: string;
	start_date: number | null;
	end_date: number | null;
	formateur_id: string | null;
}

export interface PreviewFormationSurvey {
	survey_id: string;
	results_count: number;
	expected_count: number;
}

export interface PreviewFormation {
	_id: string;
	name: string;
	start_date: number | null;
	end_date: number | null;
	respondants_count: number;
	respondants_ids: string[];
	thematiques_count: number;
	thematiques: PreviewThematique[];
	formateur_ids: string[];
	surveys: PreviewFormationSurvey[];
}

export interface PreviewSurveyMeta {
	_id: string;
	label: string;
}

export interface PreviewFormateurMeta {
	_id: string;
	first_name: string;
	last_name: string;
}

export interface PreviewResult {
	formations: PreviewFormation[];
	surveys_meta: PreviewSurveyMeta[];
	formateurs_meta: PreviewFormateurMeta[];
	date_range: { start: number; end: number } | null;
}

export interface ComputedAxe {
	_id: string;
	name: string;
	totalWeight: number;
	selected: boolean;
}

export interface GenerateGraph {
	graph: {
		_id: string;
		type: string;
		name: string;
		axis_max: number;
		show_average: boolean;
	};
	computed_axes: ComputedAxe[];
	selected_axes: string[];
}

export interface GenerateResult {
	respondant_count: number;
	report: { name: string; moderation_type: string };
	graphs: GenerateGraph[];
	comments?: GenerateCommentGroup[];
}

export interface GenerateCommentGroup {
	question: string;
	answers: string[];
}

@Injectable({ providedIn: 'root' })
export class CrossFormationReportService {
	currentPayload: CrossFormationReportPayload;
	previewResult: PreviewResult;
	generateResult: GenerateResult;

	constructor(private http: HttpClient) {}

	preview(payload: CrossFormationReportPayload): Promise<PreviewResult> {
		return this.http
			.post<PreviewResult>(
				`${environment.api.uri}/admin/cross-formation-report/preview`,
				payload,
				{ withCredentials: true }
			)
			.toPromise();
	}

	generate(payload: CrossFormationReportPayload): Promise<GenerateResult> {
		return this.http
			.post<GenerateResult>(
				`${environment.api.uri}/admin/cross-formation-report/generate`,
				payload,
				{ withCredentials: true }
			)
			.toPromise();
	}
}
